module.exports = __webpack_public_path__ + "img/confidence2.4f33660e.png";